import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import Axios from 'cccisd-axios';
import ClickButton from 'cccisd-click-button';
import Confirm from 'cccisd-confirm';
import notification from 'cccisd-notification';
import IconCheckmark from 'cccisd-icons/checkmark';
import Tooltip from 'cccisd-tooltip';

var Boilerplate = window.cccisd && window.cccisd.boilerplate;

class ApproveUser extends Component {
    static propTypes = {
        row: PropTypes.object,
        settings: PropTypes.object,
        loadData: PropTypes.func,
    };

    approve = async () => {
        const { row, loadData } = this.props;

        const pawnId = _get(row, 'pawn.pawnId');
        const pawnHash = _get(row, 'pawn.pawnHash');
        const fullName = _get(row, 'user.fullName');

        let data = {
            pawnId,
            pawnHash,
        };

        let response = await Axios.post(Boilerplate.route('approve.user.role'), data);
        if (response && response.data && response.data.status === 'success') {
            notification({
                message: `${fullName} is now approved for full access to SHIFT Wellness Resources.`,
                type: 'success',
                duration: 3000,
            });

            loadData();
        } else {
            notification({
                message: `Error approving ${fullName}.`,
                data: response && response.data && response.data.errors,
                duration: -1,
                type: 'danger',
            });
        }
    };

    confirm = () => {
        const { row } = this.props;

        const fullName = _get(row, 'user.fullName');

        Confirm({
            message: `Are you sure you want to approve ${fullName}?`,
            description: `You are about to approve ${fullName} to have full access to the SHIFT Wellness resources.`,
            confirmLabel: 'Approve',
            abortLabel: 'Cancel',
        })
            .then(() => {
                this.approve();
            })
            .fail(() => {
                // close modal
            });
    };

    render() {
        return (
            <Tooltip title="Approve User">
                <ClickButton
                    title={
                        <span>
                            <IconCheckmark />
                        </span>
                    }
                    className="btn btn-xs btn-success"
                    onClick={this.confirm}
                />
            </Tooltip>
        );
    }
}

export default ApproveUser;
